import React from 'react';
import PropTypes from 'prop-types';
import Button from 'reactstrap/lib/Button';
import { InsiderNavigationLink } from 'site-modules/profile/components/shared/insider-navigation/shared/insider-navigation-link';
import {
  INSIDER_NAVIGATION_TAB_NAMES,
  INSIDER_NAVIGATION_MAP,
  navigationFilter,
} from 'site-modules/profile/components/shared/insider-navigation/shared/insider-navigation-map';
import { AlertsBanner } from 'site-modules/profile/components/dashboard/alerts-banner/alerts-banner';

export function InsiderNavigationMobile({ signOut, savedItemsAmount }) {
  const keys = Object.keys(INSIDER_NAVIGATION_MAP).filter(key => navigationFilter(key));

  return (
    <div className="insider-nav-header-mobile mt-1_5">
      {keys.map(tabKey => {
        const isInventoryTab = tabKey === INSIDER_NAVIGATION_TAB_NAMES.INVENTORY;
        return (
          <InsiderNavigationLink
            key={tabKey}
            name={INSIDER_NAVIGATION_MAP[tabKey].tabName}
            savedItemsAmount={savedItemsAmount[tabKey]}
            link={`/insider/${tabKey}/`}
            classes="insider-mobile-tab-bordered text-primary d-block py-1_5"
            showPriceDropAlertsBanner={isInventoryTab}
            showNotification={isInventoryTab}
            showArrow
          >
            {tabKey === INSIDER_NAVIGATION_TAB_NAMES.SETTINGS && <AlertsBanner className="medium" />}
          </InsiderNavigationLink>
        );
      })}
      <Button
        outline
        block
        className="insider-nav-header-sign-out insider-mobile-tab-bordered text-capitalize text-start px-0 py-1_5 border-start-0 border-end-0 border-bottom-0 rounded-0"
        color="primary"
        data-tracking-id="sign_out"
        data-tracking-value="Sign out"
        onClick={signOut}
      >
        <span className="fw-normal">Sign Out</span>
      </Button>
    </div>
  );
}

InsiderNavigationMobile.propTypes = {
  signOut: PropTypes.func.isRequired,
  savedItemsAmount: PropTypes.shape({}).isRequired,
};
